import { render, staticRenderFns } from "./VacationCarryOverRequestCommentList.vue?vue&type=template&id=9b5b8d58&"
import script from "./VacationCarryOverRequestCommentList.vue?vue&type=script&lang=ts&"
export * from "./VacationCarryOverRequestCommentList.vue?vue&type=script&lang=ts&"
import style0 from "./VacationCarryOverRequestCommentList.vue?vue&type=style&index=0&id=9b5b8d58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports